import { assertTimeString } from "./ControlValues.js";
function splitDatetime(datetime) {
  return (datetime ?? "T").split("T");
}
function toDate(value) {
  let date;
  try {
    assertTimeString(value);
    date = new Date(`1970-01-01T${value}`);
  } catch (error) {
    date = new Date(value ?? NaN);
  }
  return isNaN(date.valueOf()) ? null : date;
}
function toDateString(value) {
  const date = toDate(value);
  if (date) {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toFixed(0).padStart(2, "0");
    const day = date.getDate().toFixed(0).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }
  return null;
}
function toTimeString(value) {
  const date = toDate(value);
  if (date) {
    const hours = date.getHours().toFixed(0).padStart(2, "0");
    const minutes = date.getMinutes().toFixed(0).padStart(2, "0");
    return `${hours}:${minutes}`;
  }
  return null;
}
function toDatetimeString(value) {
  const date = toDate(value);
  if (date) {
    return `${toDateString(date)}T${toTimeString(date)}`;
  }
  return null;
}
function toISOString(value) {
  return toDate(value)?.toISOString() ?? null;
}
export {
  splitDatetime,
  toDate,
  toDateString,
  toDatetimeString,
  toISOString,
  toTimeString
};
//# sourceMappingURL=Serializer.js.map
